module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Wood.1a5d06d7.jpg";